import { get, post } from 'aws-amplify/api';
import { replaceNullsWithEmpty } from '../utils/utils';
import { ContractingItem } from '../models/contracting.model';

export const getContractingItem = async (contractingId: string): Promise<ContractingItem> => {
  const response = await get({
    apiName: 'contracting',
    path: `/contracting/${contractingId}`,
  }).response;

  const json = (await response.body.json()) as any;
  return replaceNullsWithEmpty(json) as ContractingItem;
};

export const getContractingItems = async (filters: {
  status?: string;
  limit?: number;
  lastKey?: string;
}): Promise<{ items: ContractingItem[]; lastKey: string }> => {
  const limit = filters.limit ?? 25;
  const lastKey = filters.lastKey ?? '';
  const status = filters.status ?? '';

  const response = await get({
    apiName: 'contracting',
    path: `/contracting?limit=${limit}&lastKey=${lastKey}&status=${status}`,
  }).response;

  const json = (await response.body.json()) as any;
  return {
    items: json.items.map((a: any) => replaceNullsWithEmpty(a) as ContractingItem),
    lastKey: json.lastKey,
  };
};

export const createContractingItem = async (data: {
  dealerName?: string;
  opportunityId?: string;
  analystEmail?: string;
  firstName: string;
  lastName: string;
  email: string;
  salesTaxCollected: 'yes' | 'no';
  registrationFeesCollected: 'yes' | 'no';
  titleTransferCompleted: 'yes' | 'no';
  registrationTransferCompleted: 'yes' | 'no';
  billOfSaleFileKey: string;
  titleFrontFileKey: string;
  titleBackFileKey: string;
  dealNotes?: string;
  disclosureAgreementName?: string;
}): Promise<void> => {
  await post({
    apiName: 'contracting',
    path: '/contracting',
    options: { body: data as any },
  }).response;
};

/** Get presigned upload URL for a Contracting document. Files are stored privately (not publicly readable); use getFileDownloadUrl to view them. */
export async function getContractingUploadUrl(
  fileName: string,
  entityId?: string
): Promise<{ uploadUrl: string; fileKey: string }> {
  const response = await post({
    apiName: 'contracting',
    path: '/contracting/upload-url',
    options: {
      body: {
        fileName,
        entityId: entityId || undefined,
      } as any,
    },
  }).response;
  const json = (await response.body.json()) as { uploadUrl: string; fileKey: string };
  return json;
}

/** Get a fresh presigned GET URL for a private Contracting document (admin-only, aws_iam authorized). */
export async function getFileDownloadUrl(fileKey: string): Promise<string> {
  const response = await post({
    apiName: 'files',
    path: '/files/download-url',
    options: { body: { fileKey } as any },
  }).response;
  const json = (await response.body.json()) as { downloadUrl: string };
  return json.downloadUrl;
}
